import { useEffect, useState } from 'react'

/**
 * `value`, once it has stopped changing for `delayMs`.
 *
 * For search boxes that query the relay: typing "register" should be one request, not eight. The
 * timer is an effect's, so it is cleared when the value changes again or the component goes away,
 * which is the part the Blazor pages' hand-rolled timers forgot.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
